class ProductTabs extends HTMLElement {
    constructor() {
        super();
        
        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        
        // Existing options
        this.isVerticalPopup = this.dataset.vertical === 'sidebar';
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile';
        
        // NEW: Full Popup Options
        this.isFullPopup = this.dataset.vertical === 'popup-full';
        this.isFullPopupMobile = this.dataset.verticalMobile === 'popup-full-mobile';

        for (let i = 0; i < this.tab.length; i++) {
            this.tab[i].addEventListener('click', this.tabActive.bind(this));
        }
            
        for (let i = 0; i < this.link.length; i++) {
            this.link[i].addEventListener('click', this.tabToggle.bind(this));
        }

        document.addEventListener('click', e => {
            if (e.target.matches('[data-show-more-toogle]') || e.target.closest('[data-show-more-toogle]')) {
                this.readMoreReadLess(e);
            }
            else if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
                this.productTabClose(e);

                if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                    this.handleVerticalPopupClose(e);
                }
                
                // NEW: Handle full popup close
                if (this.isFullPopup || this.isFullPopupMobile) {
                    this.handleFullPopupClose(e);
                }
            }
        });

        // Background overlay click handler
        if (this.isVerticalPopup || this.isVerticalSidebarMobile || this.isFullPopup || this.isFullPopupMobile) {
            document.querySelector('.background-overlay')?.addEventListener('click', this.onBackgroundClick.bind(this));
        }

        // NEW: Create full popup overlay if needed
        if (this.isFullPopup || this.isFullPopupMobile) {
            this.createFullPopupOverlay();
        }

        // NEW: Close on ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.closeAllPopups();
            }
        });

        setTimeout(() => {
            if (window.innerWidth > 550) {
                const $thisContent = document.getElementById('tab-description-mobile');
                const tabHeight = $thisContent?.offsetHeight;
                const maxHeight = parseInt($thisContent?.querySelector('.tab-showMore')?.dataset.desMax);
                if (tabHeight < maxHeight) {
                    $thisContent?.querySelector('.tab-showMore')?.remove();
                }
            }
        });
    }

    // NEW: Create overlay for full popup
    createFullPopupOverlay() {
        if (!document.querySelector('.full-popup-overlay')) {
            const overlay = document.createElement('div');
            overlay.className = 'full-popup-overlay';
            document.body.appendChild(overlay);
            
            overlay.addEventListener('click', () => {
                this.closeAllPopups();
            });
        }
    }

    // NEW: Close all popups
    closeAllPopups() {
        document.querySelectorAll('.toggleLink.is-open').forEach(el => el.classList.remove('is-open'));
        document.querySelectorAll('.toggle-content.is-show').forEach(el => el.classList.remove('is-show'));
        document.querySelectorAll('.toggle-content.is-full-popup-active').forEach(el => el.classList.remove('is-full-popup-active'));
        document.body.classList.remove('tab-popup-show', 'tab-full-popup-show');
        document.querySelector('.full-popup-overlay')?.classList.remove('is-active');
    }
    
    tabActive(event) {
        event.preventDefault();
        event.stopPropagation();

        var $this = event.target,
            id = $this.getAttribute('href').replace('#', ''),
            button_tab = document.querySelector('.an-horizontal-shaking');

        if (!$this.classList.contains('is-open')) {
            this.tab.forEach((element, index) => {
                element.classList.remove('is-open');
            });

            $this.classList.add('is-open');
            this.tabContents.classList.add('is-show');
            button_tab?.classList.add('open-tab-content');

            this.tabContent.forEach((element, index) => {
                if (element.getAttribute('id') == id) {
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            });
        }   

        if ($this.classList.contains('open-tab-content')) {
            button_tab?.classList.remove('open-tab-content');
        }

        this.checkTabShowMore(id);
    }

    tabToggle(event) {
        event.preventDefault();
        event.stopPropagation();
        
        var $this = event.currentTarget,
            $thisContent = $this.parentNode.nextElementSibling;

        // NEW: Check for full popup mode
        const isFullPopupMode = (this.isFullPopup && window.innerWidth > 550) || 
                                (this.isFullPopupMobile && window.innerWidth <= 550) ||
                                $this.classList.contains('popup-full') ||
                                $this.classList.contains('popup-full-mobile');

        if (isFullPopupMode) {
            if ($this.classList.contains('is-open')) {
                // Close popup
                $this.classList.remove('is-open');
                $thisContent.classList.remove('is-show', 'is-full-popup-active');
                document.body.classList.remove('tab-full-popup-show');
                document.querySelector('.full-popup-overlay')?.classList.remove('is-active');
            } else {
                // Open popup
                $this.classList.add('is-open');
                $thisContent.classList.add('is-show', 'is-full-popup-active');
                document.body.classList.add('tab-full-popup-show');
                document.querySelector('.full-popup-overlay')?.classList.add('is-active');
            }
            return;
        }

        if ($this.classList.contains('popup-mobile') && window.innerWidth <= 551) {
            if ($($thisContent).hasClass('is-show')) {
                $($thisContent).removeClass('is-show');
            } else {
                $($thisContent).addClass('is-show');
            }
        } else {
            if (window.innerWidth <= 551 && $this.classList.contains('show-mobile')) {
                $this.classList.remove('is-open');
                $this.classList.remove('show-mobile');
                $($thisContent).slideUp('slow');
            } else if ($this.classList.contains('is-open')) {
                $this.classList.remove('is-open');
                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.matches('.sidebar-mobile') && window.innerWidth <= 550)) {
                    $thisContent.classList.remove('is-show');
                    document.body.classList.remove('tab-popup-show');
                } else {
                    $($thisContent).slideUp('slow');
                }
            } else {
                $this.classList.add('is-open');
                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.classList.contains('sidebar-mobile') && window.innerWidth <= 550)) {
                    document.body.classList.add('tab-popup-sidebar-show');
                    $thisContent.classList.add('is-show');
                    document.body.classList.add('tab-popup-show');
                } else {
                    $($thisContent).slideDown('slow');
                }
            }
        }
    }

    readMoreReadLess(event) {
        event.preventDefault();
        event.stopPropagation();

        var $this = event.target || event.target.closest('[data-show-more-toogle]'),
            id = $this.getAttribute('href').replace('#', ''),
            textShowMore = $this.getAttribute('data-show-more-text'),
            textShowLess = $this.getAttribute('data-show-less-text'),
            desMax = $this.closest('.tab-showMore').dataset.desMax;

        if ($this.classList.contains('is-less')) {
            $this.closest('.tab-showMore').classList.remove('is-less');
            $this.classList.remove('is-less');
            $this.closest('.tab-showMore').classList.add('is-show');
            $this.classList.add('is-show');
            $this.innerText = textShowMore;
            document.getElementById(`${id}`).style.maxHeight = `${desMax}px`;
            this.tabContents.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        } else {
            $this.closest('.tab-showMore').classList.remove('is-show');
            $this.classList.remove('is-show');
            $this.closest('.tab-showMore').classList.add('is-less');
            $this.classList.add('is-less');
            $this.innerText = textShowLess;
            document.getElementById(`${id}`).style.maxHeight = 'unset';
        }
    }

    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();

        this.tabContents.classList.remove('is-show');

        this.tab.forEach((element, index) => {
            element.classList.remove('is-open');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        this.tabContent.forEach((element, index) => {
            element.classList.remove('is-active');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        if (window.innerWidth <= 551) {
            const $toggleContent = event.target.closest('.toggle-content');
            $toggleContent?.classList.remove('is-show');
        }
    }

    checkTabShowMore(id) {
        if (window.innerWidth > 550) {
            const $thisContent = document.getElementById(`${id}`);
            const tabHeight = $thisContent?.offsetHeight;
            const maxHeight = parseInt($thisContent?.querySelector('.tab-showMore')?.dataset.desMax);
            if (tabHeight < maxHeight) {
                $thisContent?.querySelector('.tab-showMore')?.remove();
            }
        }
    }

    onBackgroundClick(event) {
        if (event.target.closest('.toggle-content.is-show') != null) return;
        this.closeAllPopups();
    }

    handleVerticalPopupClose(event) {
        const icon = event.target;
        icon.closest('.toggle-content')?.classList.remove('is-show');
        icon.closest('.tab-content')?.querySelector('.toggleLink')?.classList.remove('is-open');
        document.body.classList.remove('tab-popup-show');
    }

    // NEW: Handle full popup close
    handleFullPopupClose(event) {
        const icon = event.target;
        const toggleContent = icon.closest('.toggle-content');
        
        toggleContent?.classList.remove('is-show', 'is-full-popup-active');
        icon.closest('.tab-content')?.querySelector('.toggleLink')?.classList.remove('is-open');
        document.body.classList.remove('tab-full-popup-show');
        document.querySelector('.full-popup-overlay')?.classList.remove('is-active');
    }
}

customElements.define('product-tab', ProductTabs);